import React, { useEffect, useMemo } from 'react';
import { Tabs, Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import { hasResource } from '../../../utils/resourceAuth';
import { ResourceCode } from '../../../constants/resourceCodes';
import { useHashState } from '../../../utils/hashState';
import SettlementBillList from './SettlementBillList';
import SettlementDspBillList from './settlementDspBillList';

const SettlementBillMainPage: React.FC = () => {
    const { t } = useTranslation();
    const hasRevenue = hasResource([ResourceCode.settlement.SETTLEMENT_REVENUE_BILL_CHECK]);
    const hasCost = hasResource([ResourceCode.settlement.SETTLEMENT_COST_BILL_CHECK]);

    const defaultTabKey = hasRevenue ? 'client' : hasCost ? 'dsp' : '';
    const [activeTab, setActiveTab] = useHashState({ tab: defaultTabKey });

    const items = useMemo(() => {
        const tabs = [];
        if (hasRevenue) {
            tabs.push({
                label: t('settlement.settlementBill.tabs.clientBill'),
                key: 'client',
                children: <SettlementBillList />
            });
        }
        if (hasCost) {
            tabs.push({
                label: t('settlement.settlementBill.tabs.dspBill'),
                key: 'dsp',
                children: <SettlementDspBillList />
            });
        }
        return tabs;
    }, [t, hasRevenue, hasCost]);

    const validKeySet = useMemo(() => new Set(items.map(item => item.key)), [items]);
    const resolvedActiveKey = validKeySet.has(activeTab.tab) ? activeTab.tab : items[0]?.key;

    useEffect(() => {
        if (!resolvedActiveKey || resolvedActiveKey === activeTab.tab) {
            return;
        }
        setActiveTab({ tab: resolvedActiveKey });
    }, [resolvedActiveKey, activeTab.tab, setActiveTab]);

    if (!items.length) {
        return (
            <div className="p-6">
                <Empty description="暂无权限查看账单" />
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-sm p-6">
            <Tabs
                items={items}
                size="large"
                activeKey={resolvedActiveKey}
                onChange={(key) => setActiveTab({ tab: key })}
                destroyInactiveTabPane={true}
            />
        </div>
    );
};

export default SettlementBillMainPage;
